// eslint-disable-next-line import/prefer-default-export
export const RESOLUTION_SIZES = [2, 1.5, 1.25]
